import { host } from "config/api.config";
import { FilterType } from "model/filter.model";
import { RestaurantOccupationGraphicData } from "model/graphics/restaurantOccupationGraphicData.model";
import { RoomReservationGraphicData } from "model/graphics/roomReservationGraphicData.model";
import { useHTTPClient } from "services/httpClient.service";

const url = `${host}/graphic`

export function useGetRoomReservationGraphicDataApi(){
    const {data, loading, error, get} = useHTTPClient<RoomReservationGraphicData[]>(`${url}/room-reservation`)

    async function getApi(filter: FilterType){
        if(!filter?.rooms || filter.rooms.length <= 0) return
        const u = `${url}/room-reservation?startDate=${filter?.startDate?.toISOString()}&endDate=${filter?.endDate?.toISOString()}&room=${filter.rooms[0].id}`
        const response = await get({_url: u})
        return response
    }

    return {
        loading,
        error: error,
        get: getApi,
        data
    }
}

export function useGetRestaurantOccupationGraphicDataApi(){
    const {data, loading, error, get} = useHTTPClient<RestaurantOccupationGraphicData[]>(`${url}/restaurant-occupation`)

    async function getApi(filter: FilterType){
        if(!filter?.rooms || filter.rooms.length <= 0) return
        const u = `${url}/restaurant-occupation?startDate=${filter?.startDate?.toISOString()}&endDate=${filter?.endDate?.toISOString()}&room=${filter.rooms[0].id}`
        const response = await get({_url: u})
        return response
    }

    return {
        loading,
        error: error,
        get: getApi,
        data
    }
}